import axios from '../../../http';
import formatModel from './format-model';

function initialState() {
  return {
    compareFuel: null,
    switchType: null,
    postCode: null,
    address: {
      addressLine1: null,
      addressLine2: null,
      town: null,
      county: null,
      postCode: null,
      mpan: null,
      mprn: null
    },
    tariffId: null,
    tariffName: null,
    supplierId: null,
    supplierName: null,
    tariffValidToDate: null,
    currentPayMethod: null,
    utilityPeriod: "Annually",
    currentCostEstimated: null,
    currentUsageEstimated: null,

    emailAddress: null,
    accountManagementOnline: "UnInterested",
    referrerBranchCode: null,
    billConsumptionIsEstimated: true,
    isHappyToBeAutoSwitched: true,
    customerId: null,
    switchOwnerReference: null,
    newTariffPaymentMethod: "monthlyDirectDebit",

    electricityConsumptionExceedsGasConsumption: false,

    electricityCurrentPayMethod: null,
    electricitySupplierId: null,
    electricityTariffId: null,
    electricityTariffValidToDate: null,
    electricityCurrentUsageEstimated: null,

    gasCurrentPayMethod: null,
    gasSupplierId: null,
    gasTariffId: null,
    gasTariffValidToDate: null,
    gasCurrentUsageEstimated: null,

    editMode: { prop: '' }
  };
}

const state = initialState();

const getters = {
  quote: state => state,
  notPrePaymentMeter: state => !(state.currentPayMethod === 'prePaymentMeter' || state.electricityCurrentPayMethod === 'prePaymentMeter' || state.gasCurrentPayMethod === 'prePaymentMeter')
};

const actions = {
  initialiseState({ commit }) {
    const storage = localStorage.getItem('quote');

    if (storage) {
      commit('updateState', { prop: 'quote', value: JSON.parse(storage) });
    }

    return {};
  },
  async getCustomer({ commit, dispatch }, customerId) {
    try {
      dispatch('page_loader/start', 0, { root: true });

      const res = await axios({
        method: 'GET',
        url: `request/customer/eliq/user/${customerId}/details`
      });

      const customer = res.data;
      const compareFuel = determineCompareFuel(customer);

      commit('mergeState', {
        ...customer,
        switchType: lowerCaseFirstLetter(customer.switchType),
        currentPayMethod: lowerCaseFirstLetter(customer.currentPayMethod),
        electricityCurrentPayMethod: lowerCaseFirstLetter(customer.electricityCurrentPayMethod),
        gasCurrentPayMethod: lowerCaseFirstLetter(customer.gasCurrentPayMethod),
        switchOwnerReference: customerId,
        compareFuel
      });

      dispatch('storage/save', {
        prop: 'referrerBranchCode',
        value: customer.referrerBranchCode
      }, { root: true });

    } catch (error) {
      console.log(error);
    } finally {
      dispatch('page_loader/stop', null, { root: true });
    }
  },
  async createQuote({ state, rootGetters, rootState, dispatch }) {
    const switchType = state.switchType;
    const data = formatModel(state);
    const url = {
      gasToGas: '/request/switch/v2/gas',
      electricityToElectricity: '/request/switch/v2/electricity',
      dualConsolidatedToDualConsolidated: '/request/switch/v2/dual-consolidated',
      dualDistinctToDualConsolidated: '/request/switch/v2/dual-distinct'
    };

    try {
      const res = await axios({
        method: 'POST',
        url: url[switchType],
        data
      });

      if (res.status === 200) {
        return await dispatch('storage/save', {
          prop: 'quote',
          value: {
            switchId: res.data.geniusSwitchDto.switchId,
            switchType,
            includeAllPayMethodOptions: true,
            proposedPayMethod: data.newTariffPaymentMethod,
            electricitySmartMeterInstalled: state.electricitySmartMeterInstalled == true,
            gasSmartMeterInstalled: state.gasSmartMeterInstalled == true
          }
        }, { root: true });
      }
    } catch (error) {
      return error.data.message;
    }
  }
};

const mutations = {
  updateState(state, { prop, value }) {
    state[prop] = value;
  },
  mergeState(state, data) {
    state = Object.assign(state, data);
  },
  resetState(state) {
    Object.assign(state, initialState());
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};


function determineCompareFuel(data) {
  switch (data.switchType) {
    case 'GasToGas':
      return 'gas';

    case 'ElectricityToElectricity':
      return 'electricity';

    default:
      return 'gasElectricity';
  };
}

function lowerCaseFirstLetter(string) {
  if (!string) return null;
  return string.charAt(0).toLowerCase() + string.slice(1);
}
